import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/favicon-96x96.png")